import type AppBrand from '@/services/app-branding/types/AppBrand';

/** WINCK Config */
import winckThemeConfig from '@/services/keyvue-ui/config/winck/theme-config';
import winckStyleConfig from '@/services/keyvue-ui/config/winck/style-config';
import winckFontConfig from '@/services/keyvue-ui/config/winck/font-config';

/** ASKNOA Config */
import askNoaThemeConfig from '@/services/keyvue-ui/config/asknoa/theme-config';
import askNoaStyleConfig from '@/services/keyvue-ui/config/asknoa/style-config';
import askNoaFontConfig from '@/services/keyvue-ui/config/asknoa/font-config';

export default {
    getBrandName: function getBrandName(): AppBrand {
        const brandName = import.meta.env.VITE_BRAND_NAME;

        if (brandName !== 'WINCK' && brandName !== 'ASK_NOA') {
            throw Error('Invalid app brand provided');
        }

        return brandName as AppBrand;
    },
    getStyleConfig: function getStyleConfig() {
        if (this.getBrandName() === 'ASK_NOA') {
            return askNoaStyleConfig;
        }

        return winckStyleConfig;
    },
    getFontConfig: function getFontConfig() {
        if (this.getBrandName() === 'ASK_NOA') {
            return askNoaFontConfig;
        }

        return winckFontConfig;
    },
    getThemeConfig: function getThemeConfig() {
        if (this.getBrandName() === 'ASK_NOA') {
            return askNoaThemeConfig;
        }

        return winckThemeConfig;
    },
};
